exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._8RbxdseVV49R6m{border-radius:3px;box-sizing:border-box;display:inline-flex;overflow:hidden;padding:6px 12px 6px 6px;position:relative;text-decoration:none}.BhLk7hyE1L79ei{background:#eddbf4}.BhLk7hyE1L79ei:hover{background:#dfc0eb}.BhLk7hyE1L79ei .mF0y-rlipxpKvj{background:#89609e}.BhLk7hyE1L79ei ._3hOaPVUXoPh9lj{color:#fff}.BhLk7hyE1L79ei .SjSnrkndhUYwrg{color:#42526e}._3jzxIyxxHiYEAx{background:#89609e}._3jzxIyxxHiYEAx:hover{background:#583f68}._3jzxIyxxHiYEAx:hover ._3hOaPVUXoPh9lj{color:#583f68}._3jzxIyxxHiYEAx .mF0y-rlipxpKvj{background:#fff}._3jzxIyxxHiYEAx ._3hOaPVUXoPh9lj{color:#89609e}._3jzxIyxxHiYEAx .SjSnrkndhUYwrg{color:#fff}.mF0y-rlipxpKvj{border-radius:2px;height:20px;margin-right:8px;width:20px}", ""]);

// exports
exports.locals = {
	"upgradePromptButton": "_8RbxdseVV49R6m",
	"upgradePromptButtonLightTheme": "BhLk7hyE1L79ei",
	"upgradePromptButtonIconBackground": "mF0y-rlipxpKvj",
	"upgradePromptButtonIcon": "_3hOaPVUXoPh9lj",
	"upgradePromptButtonCTA": "SjSnrkndhUYwrg",
	"upgradePromptButtonDarkTheme": "_3jzxIyxxHiYEAx"
};